export const IMAGEKIT_BASE_URL = "https://ik.imagekit.io/od8mtojqv";